import * as actions from '../actions';
import { deepCloneObj } from '../../utils/utils';
import { produce } from 'immer';

const initialState = {
  dishtypes: [],
  categories: [],
  rdpPairing: null,
  savedRdpPairing: null,
};

const featuredReducer = (state = initialState, action) => {
  const newState = deepCloneObj(state);
  switch (action.type) {
    case actions.GET_DISHTYPES:
      newState.dishtypes = action.dishtypes;
      return newState;
    case actions.GET_CATEGORIES:
      newState.categories = action.categories;
      return newState;
    case actions.TOGGLE_RDP_MODAL:
      // saving RDP in the modal to allow the swap:
      let savedRdpPairing;
      if (state.rdpPairing === null && action.pairingInCart) {
        savedRdpPairing = action.pairing;
      } else if (action.pairing === null) {
        savedRdpPairing = null;
      } else {
        savedRdpPairing = state.savedRdpPairing;
      }
      return Object.assign(newState, {
        rdpPairing: action.pairing,
        savedRdpPairing,
        originalIngredients: action.originalIngredients,
      });
    case 'RECIPE_FAVORITE_CHANGE':
      return produce(state, (draft) => {
        if (
          draft.rdpPairing !== null &&
          draft.rdpPairing.id === action.recipeId
        ) {
          draft.rdpPairing.is_favorited = action.isFavorite;
        }
        if (
          draft.savedRdpPairing !== null &&
          draft.savedRdpPairing.id === action.recipeId
        ) {
          draft.savedRdpPairing.is_favorited = action.isFavorite;
        }
      });
    default:
      return state;
  }
};

export default featuredReducer;
